const COLORS = {
  Backend: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
  Frontend: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-950 dark:text-indigo-300',
  Azure: 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300',
  DevOps: 'bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-300',
  General: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
};

export default function TagBadge({ tag, size = 'sm', onClick }) {
  const color = COLORS[tag] || COLORS.General;
  const sizeClass = size === 'md'
    ? 'text-sm px-3 py-1'
    : 'text-xs px-2.5 py-0.5';

  return (
    <span
      data-testid={`tag-badge-${tag}`}
      onClick={onClick}
      className={`inline-flex items-center rounded-full font-medium transition-opacity ${onClick ? 'cursor-pointer hover:opacity-75' : ''} ${sizeClass} ${color}`}
    >
      {tag}
    </span>
  );
}
